const DEFAULT_REDIRECT_PATH = "/home";

export const isValidInternalPath = (path: string): boolean => {
  if (!path.startsWith("/")) return false;
  if (path.startsWith("//")) return false;
  if (/^https?:\/\//i.test(path)) return false;
  return true;
};

export const getSafeRedirectPath = (path: string | null): string => {
  if (!path) return DEFAULT_REDIRECT_PATH;
  return isValidInternalPath(path) ? path : DEFAULT_REDIRECT_PATH;
};
